export default __webpack_public_path__ + "static/media/API_futbol.66aa7fc2.png";